var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCumulativeObservations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 144,
    viewBox: "0 0 236 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.732422,
    width: 236,
    height: 143,
    rx: 8,
    fill: "#F3F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 58.7324,
    width: 24,
    height: 85,
    rx: 5,
    fill: "#34B3F1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 99.7324,
    width: 24,
    height: 44,
    rx: 5,
    fill: "#00E096"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 42.7324,
    width: 24,
    height: 101,
    rx: 5,
    fill: "#34B3F1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 90.7324,
    width: 24,
    height: 53,
    rx: 5,
    fill: "#00E096"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 30.7324,
    width: 24,
    height: 113,
    rx: 5,
    fill: "#34B3F1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 84.7324,
    width: 24,
    height: 59,
    rx: 5,
    fill: "#00E096"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 30.7324,
    width: 24,
    height: 113,
    rx: 5,
    fill: "#34B3F1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 84.7324,
    width: 24,
    height: 59,
    rx: 5,
    fill: "#00E096"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 78.7324,
    width: 24,
    height: 65,
    rx: 5,
    fill: "#34B3F1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 109.732,
    width: 24,
    height: 34,
    rx: 5,
    fill: "#00E096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCumulativeObservations);
export default __webpack_public_path__ + "static/media/cumulativeObservations.3d0fc70a6b448a5068978e42f20ca1bc.svg";
export { ForwardRef as ReactComponent };